var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11747 0.891591C5.21558 0.798187 5.34614 0.746549 5.4816 0.747574C5.61706 0.748599 5.74682 0.802206 5.84351 0.897085C5.94019 0.991964 5.99624 1.12069 5.99982 1.25611C6.0034 1.39152 5.95424 1.52303 5.8627 1.62289L3.08377 5.0983C3.03598 5.14976 2.97831 5.19107 2.9142 5.21974C2.85008 5.24841 2.78085 5.26386 2.71063 5.26516C2.64041 5.26646 2.57065 5.25358 2.50552 5.22731C2.44039 5.20103 2.38123 5.16189 2.33157 5.11223L0.488703 3.26935C0.437382 3.22153 0.396219 3.16387 0.367669 3.09979C0.339119 3.03571 0.323768 2.96655 0.32253 2.89641C0.321293 2.82627 0.334195 2.7566 0.360466 2.69156C0.386738 2.62652 0.425841 2.56743 0.475443 2.51783C0.525045 2.46823 0.58413 2.42913 0.649172 2.40286C0.714215 2.37658 0.783883 2.36368 0.85402 2.36492C0.924157 2.36616 0.993326 2.38151 1.0574 2.41006C1.12148 2.43861 1.17914 2.47977 1.22697 2.53109L2.68538 3.98881L5.10424 0.906914C5.10859 0.901552 5.11324 0.896436 5.11817 0.891591H5.11747Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkbox_icon.9860cde0991dc700ac622c89d87f5127.svg";
export { ForwardRef as ReactComponent };